var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgetyourpassword"},[_c('h1',[_vm._v("パスワード設定")]),_c('ForgetYourPassword',{attrs:{"isAdmin":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }